import React from 'react';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';

/**
 * A card component displaying the user's current balance
 * 
 * @param {Object} props - Component props
 * @param {number} props.balance - User's current balance
 * @param {boolean} props.showBuyButton - Whether to show the "Buy Electricity" button
 * @param {string} props.buttonText - Text to display on the buy button
 */
const BalanceCard = ({ balance, showBuyButton = true, buttonText = 'Buy Electricity' }) => {
  return (
    <div className="card bg-beige-40 shadow-md rounded-lg p-6">
      <h2 className="hooray-dark-text text-sm font-semibold uppercase mb-2">Current Balance</h2>
      <div className="flex items-baseline">
        <span className="text-3xl font-bold text-primary">
          R {(typeof balance === 'number' ? balance.toFixed(2) : '0.00')}
        </span>
      </div>
      {showBuyButton && (
        <Link 
          to="/billing" 
          className="mt-4 btn btn-primary w-full block text-center py-2 px-4 bg-blue-500 hover:bg-blue-600 text-white font-bold rounded"
        >
          {buttonText}
        </Link>
      )}
    </div>
  );
};

BalanceCard.propTypes = {
  balance: PropTypes.number,
  showBuyButton: PropTypes.bool,
  buttonText: PropTypes.string
};

export default BalanceCard; 